<template>
	<hr class="w-full h-2 bg-gradient-to-r from-portage-500 to-lavender-500 border-none hidden md:block" />
	<RouterView />
</template>
